module.exports = __webpack_public_path__ + "img/SenateLive_Icon_color_fe390q.70120b4f.png";